const ROLES = {
    ROLE_ADMIN:'ROLE_ADMIN',
    ROLE_STAFF:'ROLE_STAFF',
    ROLE_XSD:'ROLE_XSD',
    ROLE_VALUELIST:'ROLE_VALUELIST',
}

export default ROLES;